import moment from "moment";

export class CommonInfo {
    public static Weekdays: any[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    public static TimeFormat: any[] = [{ key: 0, value: '12 hour' },
    { key: 1, value: '24 hour' }]
    public static SideToggle: any = true;
    public static DateFormat = [
        moment().format('dddd, D MMMM YYYY'),      // January, Monday 14, 2024
        moment().format('dddd Do MMMM YYYY'),      // January, Monday 14, 2024
        moment().format('MMMM, dddd D, YYYY'),      // January, Monday 14, 2024
        moment().format('MMMM, DD, YYYY'),          // January, 14, 2024
        moment().format('DD/MM/YYYY'),              // 14/01/2024
        moment().format('MM/DD/YYYY')
    ]
    public static authToken: string = "";
    public static loginUrl: string = "";
    public static dateFormatCompare = {
        'MMMM, dddd D, YYYY': moment().format('MMMM, dddd D, YYYY'),      // January, Monday 14, 2024,
        'MMMM, DD, YYYY': moment().format('MMMM, DD, YYYY'),          // January, 14, 2024
        "dd/MM/yyyy": moment().format('DD/MM/YYYY'),
        'MM/DD/YYYY': moment().format('MM/DD/YYYY'),
        'MM/dd/yyyy': moment().format('MM/DD/YYYY'),
        "MMMM, d, yyyy": moment().format('MMMM, DD, YYYY'),
        "MMMM, dddd d, yyyy": moment().format('MMMM, dddd D, YYYY'),
        "d, MMMM, yyyy": moment().format('DD/MM/YYYY'),
        'dddd, D MMMM YYYY': moment().format('dddd, D MMMM YYYY'),      // January, Monday 14, 2024
        'dddd Do MMMM YYYY': moment().format('dddd Do MMMM YYYY'),

    };


    public static resetValues(): void {
        localStorage.removeItem('authToken');
        localStorage.removeItem('tenantUrl');
        localStorage.removeItem('currentUrl');
        localStorage.removeItem('userId');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('UserName');
        localStorage.clear();
        this.SideToggle = false;
        this.authToken = "";
        this.loginUrl = "";
        // Reset or re-initialize any static properties here
    }

    // public static folderName = '/officeapp/' //Production
    public static folderName = '/officeappV2' //Development
    // public static folderName = '' //Localhost

    public static configurl = ""

    private static authResultGlobal = "";

    /**
     * Get auth result param. 
     * @returns SSO auth result param
     */
    public static getAuthResult() {
        return this.authResultGlobal;
    }
    /**
     * Set the auth result global param. 
     * @param thatAuthResultGlobal Auth result from SSO
     */
    public static setAuthResult(thatAuthResultGlobal: string) {
        this.authResultGlobal = thatAuthResultGlobal;
    }
    /**
     * Log data to console. This essentially does a Console.Writeline()
     * @param messageToLog Message to log to console.
     */
    public static logToConsole(messageToLog: string): void {
        // if(process.env.LOG_STATE == "DEBUG") {
        // }
    }

    public static workingDays: any
}